import { GetScenarioSettingByScenarioIdDocument } from '@/generated/graphql';
import { useQuery } from '@vue/apollo-composable';
import { DateTime } from 'luxon';
import { computed, Ref, toValue } from 'vue';

export function useScenarioSetting(scenarioId: Ref<string>) {
    const { result: getSetting } = useQuery(
        GetScenarioSettingByScenarioIdDocument,
        computed(() => ({
            scenarioId: toValue(scenarioId),
        })),
    );
    const setting = computed(() => getSetting.value?.scenarioSetting);

    const scenarioLinkButtonVariant = computed(() => {
        if (setting.value) {
            return 'Stored-Scenario';
        }
        return 'No-Stored-Scenario';
    });

    const scenarioLinkButtonTarget = computed(() => {
        if (setting.value) {
            const { start, showSections } = setting.value;
            const settingYear = DateTime.fromISO(start).year;
            const settingQuarter = DateTime.fromISO(start).quarter;
            const settingTimelineDisplay = showSections ? 'sections' : 'hierarchy';
            return {
                name: 'allocation-designer',
                query: {
                    'scenario-id': toValue(scenarioId),
                    year: settingYear,
                    quarter: settingQuarter,
                    'timeline-display': settingTimelineDisplay,
                },
            };
        } else {
            return { name: 'allocation-designer', query: { 'scenario-id': toValue(scenarioId) } };
        }
    });

    return {
        setting,
        scenarioLinkButtonVariant,
        scenarioLinkButtonTarget,
    };
}
